
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/akun",
      function () {
        return require("private-next-pages/akun.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/akun"])
      });
    }
  